/**
 * Плечи доставки, по которым назначаются тарифная карта и скидка партнёра.
 *
 * Те же четыре значения в api-calculator, slq-graph-service и api-market —
 * названия здесь только для показа оператору.
 */
export const MILE_TYPES = [
  { value: "FIRST", label: "Первая миля" },
  { value: "MIDDLE", label: "Магистраль" },
  { value: "LAST", label: "Последняя миля" },
  { value: "INTRACITY", label: "Внутригород" },
];

export const mileLabel = (value) =>
  MILE_TYPES.find((mile) => mile.value === value)?.label ?? value ?? "—";

/**
 * Комплект — карта без плеча (расчёт v2): одна книга с разделами забор /
 * магистраль / доставка (+ внутригород), назначается субъекту целиком.
 */
export const isTariffSet = (plan) => Boolean(plan) && !plan.mileType;

/** Вид карты для показа: плечо у одноплечей, «Комплект» у комплекта. */
export const planKindLabel = (plan) => (isTariffSet(plan) ? "Комплект" : mileLabel(plan?.mileType));
